<template>
  <footer id="the-footer" role="contentinfo">
    <section class="container">
      <div class="row no-gutters">

        <section class="col-md-6 social-icons">
          <a href="https://www.linkedin.com/in/rachel-emily-hirshan/" target="_blank" aria-label="LinkedIn Profile (opens in new tab)" rel="noopener noreferrer" role="link">
            <font-awesome-icon :icon="['fab', 'linkedin']" class="icon" />
          </a>
          <a href="https://www.facebook.com/rehwebdesigns/" target="_blank" aria-label="Facebook Profile (opens in new tab)" rel="noopener noreferrer" role="link">
            <font-awesome-icon :icon="['fab', 'facebook-square']" class="icon" />
          </a>
          <a href="https://www.instagram.com/rehwebdesigns/" target="_blank" aria-label="Instagram Profile (opens in new tab)" rel="noopener noreferrer" role="link">
            <font-awesome-icon :icon="['fab', 'instagram']" class="icon" />
          </a>
          <a href="https://twitter.com/rehwebdesigns" target="_blank" aria-label="Twitter Profile (opens in new tab)" rel="noopener noreferrer" role="link">
            <font-awesome-icon :icon="['fab', 'twitter-square']" class="icon" />
          </a>
        </section>  

        <section class="col-md-6">
          © {{ currentYear }} REH Designs
        </section>      
      </div> 
    </section>
  </footer>
</template>

<script>
export default {
  name: 'theFooter',
  props: {
    msg: String
  },
  computed: {
    currentYear () {
      return new Date().getFullYear()
    }
  }
}
</script>

<style lang="less">
@import '~../less/variables.less';
@import '~../less/global.less';

#the-footer {
  background: rgba(6, 41, 11, .95);
  bottom: 0px;
  width: 100%;
  padding: 5px 15px;
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;

  @media (min-width: @min-device-md){
    position: fixed;
  }

  .col-md-6{
    text-align: center;

    &:first-child{
      @media (min-width: @min-device-md){
       text-align: left;
      }
    }

    &:last-child{
      @media (min-width: @min-device-md){
       text-align: right;
      }
    }
  }

  .social-icons{
    font-size: 20px;
    a{
      display: inline-block;
      color: rgba(255, 255, 255, 0.5);
      margin: 0px 5px;

      &:hover{
        color: rgba(255, 255, 255, 0.75);
      }      
    }
  }

  .row{
    justify-content: center;
    align-items: center;
  }
}
</style>	